import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ReportExport } from '../types';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class ReportPortalService {
  apiHost = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);

  getReportExports(): Observable<Array<ReportExport>> {
    const requestUrl = `${this.apiHost}/ReportPortal/ReportExports`;
    return this.httpClient.get<Array<ReportExport>>(requestUrl, {});
  }

  markReportExportDownloaded(reportExportId: string): Observable<unknown> {
    const requestUrl = `${this.apiHost}/ReportPortal/ReportExports/${reportExportId}/MarkDownloaded`;
    return this.httpClient.put(requestUrl, {});
  }

  exportReportPortalData(reportExportId?: string, dateFrom?: Date, dateTo?: Date): Observable<unknown> {
    const requestUrl = `${this.apiHost}/ReportPortal/Export`;
    return this.httpClient.post(requestUrl, {
      // if existing report export id is provided, the export will be retried
      report_export_id: reportExportId,
      date_from: DateTime.fromJSDate(dateFrom).toFormat('yyyy-MM-dd'),
      date_to: DateTime.fromJSDate(dateTo).toFormat('yyyy-MM-dd'),
    });
  }
}
